import { REACT_APP_API_BASE_URL } from "constants/index";

import axios from "axios";
import storage from "utils/storage";

export const getUserPermissions = async (): Promise<any | null> => {
  const token = storage.getToken();
  const dataLogin = await axios.get("/user-permissions", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    baseURL: REACT_APP_API_BASE_URL,
  });
  return dataLogin.data as string[];
};
